export default "__VITE_ASSET__DAip9md6__"